module.exports = __webpack_public_path__ + "static/media/bitcoin_nespresso_vending_machine.b3f2f49f.mp4";